import { useEffect, useMemo, useRef, useState } from 'react';

import UserService from '@/services/user.service';

export default function useLimitedEditionShippingQuote({
  country = null,
  size = null,
  enabled = true,
} = {}) {
  const [state, setState] = useState(() => ({
    quote: null,
    loading: false,
    error: null,
  }));
  const requestIdRef = useRef(0);

  useEffect(() => {
    if (!enabled || !country || !size) {
      setState({
        quote: null,
        loading: false,
        error: null,
      });
      return () => {};
    }

    let isActive = true;
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;

    setState((prev) => ({
      ...prev,
      loading: true,
      error: null,
    }));

    UserService.getLimitedEditionShippingQuote({
      country,
      size,
    })
      .then(({ response, data }) => {
        if (!isActive || requestIdRef.current !== requestId) {
          return;
        }
        if (response?.ok && data?.quote) {
          setState({
            quote: data.quote,
            loading: false,
            error: null,
          });
        } else {
          setState({
            quote: null,
            loading: false,
            error: data ?? { error_type: 'LIMITED_EDITION_SHIPPING_QUOTE_FAILED' },
          });
        }
      })
      .catch((error) => {
        if (!isActive || requestIdRef.current !== requestId) {
          return;
        }
        setState({
          quote: null,
          loading: false,
          error,
        });
      });

    return () => {
      isActive = false;
    };
  }, [country, size, enabled]);

  return useMemo(() => ({
    quote: state.quote,
    loading: state.loading,
    error: state.error,
  }), [state.error, state.loading, state.quote]);
}
